import { AssistantFeedbackPayloadDto } from "@core/data/dto/assistant.dto";
import { AssistantRepository } from "@core/data/repositories/assistant.repository";
import { FallbackError } from "@core/domain/errors/fallback.error";
import { AssistantMessage } from "@core/domain/models/assistant-message.model";
import { Either } from "@core/domain/types/either";
import { inject, injectable } from "inversify";

@injectable()
export class SubmitAssistantFeedbackUseCase {
    constructor(
        @inject(AssistantRepository)
        private readonly repository: AssistantRepository,
    ) {}

    async execute(
        messageId: number,
        payload: AssistantFeedbackPayloadDto,
    ): Promise<Either<FallbackError, AssistantMessage>> {
        return this.repository.submitFeedback(messageId, payload);
    }
}
